<template>
  <div class="gene-panel-confirm-dailog dialog col-block">
    <div class="info-container">{{ $t('DIALOG.genePanelConfirm.___info01') }}</div>
    <div :style="{ height: '10px' }"></div>
    <div class="confirm-container col-block">
      <div v-if="data.add" class="confirm-block add-block col-block flex-start">
        <div class="block-title">{{ $t('DIALOG.genePanelConfirm.block.title.___add') }}</div>
        <div :style="{ height: '8px' }"></div>
        <div v-if="data.add['free_typing']" class="item-container gene-ft col-block flex-start">
          <div class="item-title">{{ $t('DIALOG.genePanelConfirm.block.content.___geneFreeTyping') + ':' }}</div>
          <div class="item-content">{{ data.add['free_typing'].reduce((s, data) => s + (s ? '、' : '') + (data.symbol + ' (' + data.gene_id + ')'), '') }}</div>
        </div>
        <div v-if="data.add['user_defined'] || data.add['user_defined_replace']" class="item-container gene-ud col-block flex-start">
          <div class="item-title">{{ $t('DIALOG.genePanelConfirm.block.content.___geneUserDefined') + ':' }}</div>
          <div
            class="item-content"
            v-html="[
              data.add['user_defined_replace'] ? 'Add (' + data.add['user_defined_replace'].name + ') to <b>replace present list</b>' : null,
              (data.add['user_defined'] || []).length ? data.add['user_defined'].length + (data.add['user_defined'].length > 1 ? ' genes were' : ' gene was') + ' selected' : null
            ].filter(x => x).join(', ')"
          ></div>
        </div>
        <div v-if="data.add['panel'] || data.add['panelGene']" class="item-container panel col-block flex-start">
          <div class="item-title">{{ $t('DIALOG.genePanelConfirm.block.content.___panel') + ':' }}</div>
          <div
            class="item-content"
            v-html="[
              (data.add['panel'] || []).reduce((s, panel) => s + (s ? ', ' : '') + panel.name + (panel.data.some(data => data.checked === false) ? ' (' + panel.data.filter(data => data.checked !== false).length + (panel.data.filter(data => data.checked !== false).length > 1 ? ' genes were' : ' gene was') + ' selected)' : ''), ''),
              (data.add['panelGene'] || []).reduce((s, panel) => s + (s ? ', ' : '') + panel.name + ' (' + panel.data.filter(data => new Date(data.date) > now && data.oChecked === false && data.checked !== data.oChecked).length + (panel.data.filter(data => new Date(data.date) > now && data.oChecked === false && data.checked !== data.oChecked).length > 1 ? ' genes were' : ' gene was') + ' selected)', '')
            ].filter(x => x).join(', ')"
          ></div>
        </div>
        <div v-if="data.add['hpo'] || data.add['hpoGene']" class="item-container hpo col-block flex-start">
          <div class="item-title">{{ $t('DIALOG.genePanelConfirm.block.content.___hpoPhenotypes') + ':' }}</div>
          <div
            class="item-content"
            v-html="[
              (data.add['hpo'] || []).reduce((s, hpo) => s + (s ? ', ' : '') + hpo.name + (hpo.data.some(data => data.checked === false) ? ' (' + hpo.data.filter(data => data.checked !== false).length + (hpo.data.filter(data => data.checked !== false).length > 1 ? ' genes were' : ' gene was') + ' selected)' : ''), ''),
              (data.add['hpoGene'] || []).reduce((s, hpo) => s + (s ? ', ' : '') + hpo.name + ' (' + hpo.data.filter(data => new Date(data.date) > now && data.oChecked === false && data.checked !== data.oChecked).length + (hpo.data.filter(data => new Date(data.date) > now && data.oChecked === false && data.checked !== data.oChecked).length > 1 ? ' genes were' : ' gene was') + ' selected)', '')
            ].filter(x => x).join(', ')"
          ></div>
        </div>
        <div v-if="data.add['condition'] || data.add['conditionGene']" class="item-container condition col-block flex-start">
          <div class="item-title">{{ $t('DIALOG.genePanelConfirm.block.content.___conditions') + ':' }}</div>
          <div
            class="item-content"
            v-html="[
              (data.add['condition'] || []).reduce((s, condition) => s + (s ? ', ' : '') + condition.name + (condition.data.some(data => data.checked === false) ? ' (' + condition.data.filter(data => data.checked !== false).length + (condition.data.filter(data => data.checked !== false).length > 1 ? ' genes were' : ' gene was') + ' selected)' : ''), ''),
              (data.add['conditionGene'] || []).reduce((s, condition) => s + (s ? ', ' : '') + condition.name + ' (' + condition.data.filter(data => new Date(data.date) > now && data.oChecked === false && data.checked !== data.oChecked).length + (condition.data.filter(data => new Date(data.date) > now && data.oChecked === false && data.checked !== data.oChecked).length > 1 ? ' genes were' : ' gene was') + ' selected)', '')
            ].filter(x => x).join(', ')"
          ></div>
        </div>
        <div v-if="data.add['pathway'] || data.add['pathwayGene']" class="item-container pathway col-block flex-start">
          <div class="item-title">{{ $t('DIALOG.genePanelConfirm.block.content.___pathways') + ':' }}</div>
          <div
            class="item-content"
            v-html="[
              (data.add['pathway'] || []).reduce((s, pathway) => s + (s ? ', ' : '') + pathway.name + (pathway.data.some(data => data.checked === false) ? ' (' + pathway.data.filter(data => data.checked !== false).length + (pathway.data.filter(data => data.checked !== false).length > 1 ? ' genes were' : ' gene was') + ' selected)' : ''), ''),
              (data.add['pathwayGene'] || []).reduce((s, pathway) => s + (s ? ', ' : '') + pathway.name + ' (' + pathway.data.filter(data => new Date(data.date) > now && data.oChecked === false && data.checked !== data.oChecked).length + (pathway.data.filter(data => new Date(data.date) > now && data.oChecked === false && data.checked !== data.oChecked).length > 1 ? ' genes were' : ' gene was') + ' selected)', '')
            ].filter(x => x).join(', ')"
          ></div>
        </div>
      </div>
      <hr v-if="data.add && data.remove">
      <div v-if="data.remove" class="confirm-block remove-block col-block flex-start">
        <div class="block-title">{{ $t('DIALOG.genePanelConfirm.block.title.___remove') }}</div>
        <div :style="{ height: '8px' }"></div>
        <div v-if="data.remove['free_typing']" class="item-container gene-ft col-block flex-start">
          <div class="item-title">{{ $t('DIALOG.genePanelConfirm.block.content.___geneFreeTyping') + ':' }}</div>
          <div class="item-content">{{ data.remove['free_typing'].reduce((s, data) => s + (s ? '、' : '') + (data.symbol + ' (' + data.gene_id + ')'), '') }}</div>
        </div>
        <div v-if="data.remove['user_defined']" class="item-container gene-ud col-block flex-start">
          <div class="item-title">{{ $t('DIALOG.genePanelConfirm.block.content.___geneUserDefined') + ':' }}</div>
          <div class="item-content">{{ data.remove['user_defined'].length + (data.remove['user_defined'].length > 1 ? ' genes were' : ' gene was') + ' unselected' }}</div>
        </div>
        <div v-if="data.remove['panel'] || data.remove['panelGene']" class="item-container panel col-block flex-start">
          <div class="item-title">{{ $t('DIALOG.genePanelConfirm.block.content.___panel') + ':' }}</div>
          <div
            class="item-content"
            v-html="[
              (data.remove['panel'] || []).reduce((s, panel) => s + (s ? ', ' : '') + panel.name + (panel.oLength < panel.data.length ? ' (' + panel.oLength + (panel.oLength > 1 ? ' genes were' : ' gene was') + ' unselected)' : ''), ''),
              (data.remove['panelGene'] || []).reduce((s, panel) => s + (s ? ', ' : '') + panel.name + ' (' + panel.data.filter(data => new Date(data.date) > now && data.oChecked !== false && data.checked !== data.oChecked).length + (panel.data.filter(data => new Date(data.date) > now && data.oChecked !== false && data.checked !== data.oChecked).length > 1 ? ' genes were' : ' gene was') + ' unselected)', '')
            ].filter(x => x).join(', ')"
          ></div>
        </div>
        <div v-if="data.remove['hpo'] || data.remove['hpoGene']" class="item-container hpo col-block flex-start">
          <div class="item-title">{{ $t('DIALOG.genePanelConfirm.block.content.___hpoPhenotypes') + ':' }}</div>
          <div
            class="item-content"
            v-html="[
              (data.remove['hpo'] || []).reduce((s, hpo) => s + (s ? ', ' : '') + hpo.name + (hpo.oLength < hpo.data.length ? ' (' + hpo.oLength + (hpo.oLength > 1 ? ' genes were' : ' gene was') + ' unselected)' : ''), ''),
              (data.remove['hpoGene'] || []).reduce((s, hpo) => s + (s ? ', ' : '') + hpo.name + ' (' + hpo.data.filter(data => new Date(data.date) > now && data.oChecked !== false && data.checked !== data.oChecked).length + (hpo.data.filter(data => new Date(data.date) > now && data.oChecked !== false && data.checked !== data.oChecked).length > 1 ? ' genes were' : ' gene was') + ' unselected)', '')
            ].filter(x => x).join(', ')"
          ></div>
        </div>
        <div v-if="data.remove['condition'] || data.remove['conditionGene']" class="item-container condition col-block flex-start">
          <div class="item-title">{{ $t('DIALOG.genePanelConfirm.block.content.___conditions') + ':' }}</div>
          <div
            class="item-content"
            v-html="[
              (data.remove['condition'] || []).reduce((s, condition) => s + (s ? ', ' : '') + condition.name + (condition.oLength < condition.data.length ? ' (' + condition.oLength + (condition.oLength > 1 ? ' genes were' : ' gene was') + ' unselected)' : ''), ''),
              (data.remove['conditionGene'] || []).reduce((s, condition) => s + (s ? ', ' : '') + condition.name + ' (' + condition.data.filter(data => new Date(data.date) > now && data.oChecked !== false && data.checked !== data.oChecked).length + (condition.data.filter(data => new Date(data.date) > now && data.oChecked !== false && data.checked !== data.oChecked).length > 1 ? ' genes were' : ' gene was') + ' unselected)', '')
            ].filter(x => x).join(', ')"
          ></div>
        </div>
        <div v-if="data.remove['pathway'] || data.remove['pathwayGene']" class="item-container pathway col-block flex-start">
          <div class="item-title">{{ $t('DIALOG.genePanelConfirm.block.content.___pathways') + ':' }}</div>
          <div
            class="item-content"
            v-html="[
              (data.remove['pathway'] || []).reduce((s, pathway) => s + (s ? ', ' : '') + pathway.name + (pathway.oLength < pathway.data.length ? ' (' + pathway.oLength + (pathway.oLength > 1 ? ' genes were' : ' gene was') + ' unselected)' : ''), ''),
              (data.remove['pathwayGene'] || []).reduce((s, pathway) => s + (s ? ', ' : '') + pathway.name + ' (' + pathway.data.filter(data => new Date(data.date) > now && data.oChecked !== false && data.checked !== data.oChecked).length + (pathway.data.filter(data => new Date(data.date) > now && data.oChecked !== false && data.checked !== data.oChecked).length > 1 ? ' genes were' : ' gene was') + ' unselected)', '')
            ].filter(x => x).join(', ')"
          ></div>
        </div>
      </div>
    </div>
    <div :style="{ height: '30px' }"></div>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="gray-button circle-button" @click="e => $emit('changeModal')">
        <span>{{ $t('COMMON.button.___cancel') }}</span>
      </button>
      <div :style="{ width: '20px' }"></div>
      <button class="main-button circle-button" @click="$emit('changeModal', {}, true)">
        <span>{{ $t('COMMON.button.___confirm') }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    // param
    data () {
      return this.param.data
    },
    now () {
      return this.param.now
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/genePanelConfirm.vue